<template>
  <div class="container">
    <div class="navi">
        <router-link to="/">
          <span class="icon-arrow-left"></span>
        </router-link>
    </div>
    <div class="title">我的地址</div>

    <div class="weui-cells__title">地址列表（点击可修改）</div>
      <div class="weui-cells" id="address_list">
        <a class="weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
                <p>2/9 Rose Street Chippendale NSW 2008 NSW 2008 NSW 2008</p>
            </div>
            <div class="weui-cell__ft"></div>
        </a>
        <a class="weui-cell weui-cell_access" href="javascript:;">
            <div class="weui-cell__bd">
                <p>66 Hunter Street Sydney NSW 2000 Hunter Street Sydney</p>
            </div>
            <div class="weui-cell__ft"></div>
        </a>
        <label class="weui-cell weui-check__label car">
            <div class="weui-cell__bd">
                <p class="add-more" @click="goto(vehicle_id)"> <span class="icon-plus "></span> 新增地址 </p>
            </div>
        </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'address_list',

  methods: {

  },
  created: function () {
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container #address_list /deep/ .weui-cell__bd{
  width:60%;
  p{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.container #address_list /deep/ .weui-cell{
  padding: 18px 15px;
}

.add-more{
    text-align:center;
    color:#fe9567;
}
</style>



// WEBPACK FOOTER //
// src/pages/other/address.vue